// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3Soos","modalFooterButton":"ModalNotes_modalFooterButton__2_Txm"};